import React from 'react'

export default function PresentationLayoutDiagram({ type }) {
  const family = {
    'section-title': 'section', 'title-content': 'content', 'bullet-list': 'content',
    'numbered-list': 'content', 'icon-list': 'content', 'image-text': 'content',
    'cards-grid': 'tiles', 'diagram': 'image-center',
    'chart-commentary': 'image-center', 'infographic': 'image-center',
  }[type] || type
  const lines = (x, widths = [10, 8, 11]) => widths.map((w, i) =>
    <rect key={i} x={x} y={7 + i * 4} width={w} height="1.5" rx=".7" />)
  let body
  if (family === 'blank') body = null
  else if (family === 'full-page-ad') body = <rect className="layout-image" x="1" y="1" width="38" height="23" rx="2" />
  else if (family === 'table') body = <><rect x="4" y="6" width="32" height="15" rx="1" /><path d="M4 11h32M14 6v15M25 6v15" /></>
  else if (family === 'tiles') body = <><rect x="4" y="6" width="14" height="6" rx="1" /><rect x="22" y="6" width="14" height="6" rx="1" /><rect x="4" y="15" width="14" height="6" rx="1" /><rect x="22" y="15" width="14" height="6" rx="1" /></>
  else if (family === 'image-center') body = <rect className="layout-image" x="11" y="6" width="18" height="15" rx="1" />
  else if (family === 'two-columns') body = <>{lines(4, [13, 11, 12])}{lines(22, [14, 11, 13])}</>
  else if (family === 'cover') body = <><rect x="4" y="9" width="24" height="3" rx="1" /><rect x="4" y="15" width="14" height="1.5" rx=".7" /><rect x="4" y="19" width="10" height="1.5" rx=".7" /></>
  else if (family === 'section') body = <rect x="4" y="11" width="26" height="3" rx="1" />
  else if (family === 'thanks') body = <><rect x="4" y="9" width="22" height="3" rx="1" /><rect className="layout-image" x="28" y="7" width="8" height="10" rx="1" /></>
  else body = lines(5, [30, 24, 28, 20])
  return <svg className="layout-diagram" viewBox="0 0 40 25" aria-hidden="true"><rect className="layout-page" x="1" y="1" width="38" height="23" rx="2" />{family !== 'full-page-ad' && <rect x="4" y="3.5" width="21" height="1.5" rx=".7" />}{body}</svg>
}
